import React from 'react'
import PropTypes from 'prop-types'
import { GlobalStyle, Exportable } from './LineChart.styles'
import Highcharts from 'highcharts'
import HighchartsSankey from 'highcharts/modules/sankey'
import HighchartsReact from 'highcharts-react-official'
import exportToImage from '../../modules/utils/exports'
import theme from '../../config/styles/theme'

HighchartsSankey(Highcharts)

const SankeyChart = ({ data, id, inputSankeyChartRef, fileName }) => {
  const options = {
    accessibility: { enabled: false },
    title: {
      text: ''
    },
    tooltip: {
      enabled: false
    },
    plotOptions: {
      series: {
        linkOpacity: 0.9,
        states: {
          inactive: {
            linkOpacity: 0.6
          }
        }
      }
    },
    series: [
      {
        data,
        colors: [
          theme.palette.brand.primary,
          theme.palette.charts.moodyBlue,
          theme.palette.charts.shadeBlue,
          theme.palette.charts.toryBlue,
          theme.palette.charts.jacksonsPurple,
          theme.palette.charts.moodyBlue,
          theme.palette.charts.shadeBlue,
          theme.palette.charts.toryBlue,
          theme.palette.charts.jacksonsPurple,
          theme.palette.charts.moodyBlue,
          theme.palette.charts.shadeBlue
        ],
        minLinkWidth: 30,
        type: 'sankey',
        name: '',
        dataLabels: {
          color: theme.palette.brand.white,
          style: {
            textOutline: 'none',
            fontWeight: 'light',
            fontSize: '12px'
          }
        }
      }
    ]
  }

  const exportData = () => {
    exportToImage(id, fileName)
  }

  return (
    <>
      <GlobalStyle />
      <Exportable id={id}>
        <HighchartsReact highcharts={Highcharts} options={options} />
        <Exportable onClick={exportData} ref={inputSankeyChartRef} />
      </Exportable>
    </>
  )
}

SankeyChart.defaultProps = {
  id: 'sankeyChart'
}

SankeyChart.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      color: PropTypes.string,
      from: PropTypes.string,
      to: PropTypes.string,
      weight: PropTypes.number
    })
  ).isRequired,
  id: PropTypes.string,
  inputSankeyChartRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(window.HTMLDivElement) })
  ]),
  fileName: PropTypes.string.isRequired
}

export default SankeyChart
